import axios from 'axios';
import React, { useState, useEffect } from "react";
import Sidebar from '../../components/sidebar/Sidebar';
import { io } from "socket.io-client"; // Import socket.io
import "./messages.css";
import ConversationList from '../../components/messages/ConversationList';
import MessageLog from '../../components/messages/Messagelog';
import { useLocation } from 'react-router-dom';

export default function MessagesPage() {
    const uri = process.env.REACT_APP_URI;     // Backend API URI, e.g., http:// or :5050/api
    //const socket = io(process.env.REACT_APP_NOAPI); // Socket.io connection, e.g., http://localhost:5050
    const socket = io(process.env.REACT_APP_NOAPI, {
        transports: ['websocket'], // Use WebSocket transport)
    });
    const location = useLocation();
    // console.log("REACT_APP_SOURCE_ENV:", process.env.REACT_APP_SOURCE_ENV);
    // const { currentUsername, otherUsername } = location.state || {};
    //const { currentUsername } = useContext(UserContext);
    const [conversationIds, setConversationIds] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');
    const [otherUsername, setOtherUsername] = useState('');
    const [message, setMessage] = useState('');
    const [messageList, setMessageList] = useState([]);
    const [currentConversation, setCurrentConversation] = useState(null);
    const [currentUsername, setCurrentUsername] = useState('');
    


    // Function to send a message
    const send = async (e) => {
        e.preventDefault();
        if (!currentConversation) return;
        const messageContent = document.getElementById("message-input").value;
        //.log(currentConversation);
        const messageObj = {
            sender: currentUsername,
            destination: currentConversation.users.filter(user => user !== currentUsername)[0],
            id: currentConversation._id,
            message_content: messageContent,
            datetime: Date.now()
        };
        try {
            // Create and save the message to the database
            const newMessage = await axios.post(`${uri}/messages/newMessage`, messageObj);
            console.log("message sent: ",newMessage.data);
            // Emit message to the server
            socket.emit("messageOut", { ...messageObj, _id: newMessage.data._id });
            //console.log("message sent to socket:", { ...messageObj, _id: newMessage.data._id });
            //console.log("messge object:", ...messageObj);
            console.log("newMessage_id:", newMessage.data._id);
            console.log("currentConversation_id:", currentConversation._id);
            await axios.post(`${uri}/messages/addMessageConversation`, {
                conversationId: currentConversation._id,
                messageId: newMessage.data._id
            });
            // Clear input
            setMessage('');
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    // Listen for incoming messages
//     // 
//     useEffect(() => {
//     if (!currentConversation) {
//         console.log("No current conversation selected.");
//         return;
//     }
//     console.log("Listening for messages in conversation:", currentConversation._id);
//     const handler = (newMessage) => {
//         console.log("Message received from socket:", newMessage);
//         console.log("new message id:", newMessage.id);
//         if (newMessage.id === currentConversation._id) {
//             setMessageList(prevMessages => [...prevMessages, newMessage]);
//         }
//     };

//     socket.on('messageIn', handler);

//     return () => {
//         console.log("Cleaning up message listener for conversation:", currentConversation._id);
//         socket.off('messageIn', handler); // Cleanup to prevent stacking listeners
//     };
// }, [currentConversation]);

    // Listen for incoming messages
    useEffect(() => {
        socket.on('messageIn', (newMessage) => {
            console.log("Message received:", newMessage);
            // If the new message belongs to the current conversation, update the message list
            if (newMessage.id === currentConversation?._id) {
                setMessageList(prevMessages => [...prevMessages, newMessage]);
            }
        });

        return () => {
            socket.off('messageIn'); // Cleanup on component unmount
        };
    }, [currentConversation]);




useEffect(() => {
    // Fetch the current user and their conversations when the component mounts
    console.log("Fetching current user and conversations...");
    axios.get(`${uri}/users/findUser`, { withCredentials: true })
        .then(response => {
            console.log("currentUsername", response.data.username);
            setCurrentUsername(response.data.username);
            // socket.emit('register', response.data.username);
            // console.log("Socket registered with username:", response.data.username);



            // If a username is provided in the location state, set it as otherUsername
            if (location.state?.routeUsername) {
                console.log("Setting otherUsername from location state:", location.state.username);
                setOtherUsername(location.state.routeUsername);
            } 

            return axios.get(`${uri}/users/getConversations/${response.data.username}`);
        })
        .then(response => {
            // should be an array of conversationIds
            const conversations = Array.isArray(response.data) ? response.data : [response.data];
            setConversationIds(conversations);
            //console.log("setConversationIds", conversations);
        })
        .catch(error => {
            console.error('Error fetching conversations:', error);
            console.log(otherUsername, currentUsername);
        });

}, []); 

    // Effect to handle the creation of a conversation if redirected from the otherUser's profile
    useEffect(() => {
        if (otherUsername && currentUsername) {     // won't currentUsernmae always be defined?
            console.log('otherUsername and currentUsername have been defined:',otherUsername,',',currentUsername);
            handleCreateConversation();
        }
    },  [currentUsername,otherUsername]); // pulls up the createConversation function when both currentUsername and otherUsername 


    // Effect to log conversation IDs whenever they change
    useEffect(() => {
        console.log('Updated Conversation IDs:', conversationIds);
    }, [conversationIds]);


    const handleOpenModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        setOtherUsername('');
        setError('');
    };



    const handleCreateConversation = async () => {
        console.log("creating conversation..", otherUsername);
        // console.log("current..", currentUsername);
        try {
            const response = await axios.post(`${uri}/messages/conversation`, {
             currentUsername,
                otherUsername
            });

            if (response.status === 201) {
                alert('Conversation created successfully');
                setConversationIds(prevConversations => [...prevConversations, response.data]);
                setCurrentConversation(response.data);
                handleCloseModal();
            } else if (response.status === 404) {
                setError('User not found');
            } else if (response.status === 200) {
                // if conversation already exists, direct user to the conversation
                handleCloseModal();
                setCurrentConversation(response.data)
            }
        } catch (error) {
            console.error('Error creating conversation:', error);
            setError('Something went wrong, please try again.');
        }
    };

    const deleteConversation = async () => {
        try {
            const response = await axios.delete(`${uri}/messages/conversation/${currentConversation._id}`);
            if (response.status === 200) {
                // alert('Conversation deleted successfully');
                setConversationIds(prevConversations =>
                    prevConversations.filter(convo => convo._id !== currentConversation._id)
                );
                setCurrentConversation(null);

                
            } else if (response.status === 404) {
                setError('Conversation not found');
            }
        } catch (error) {
            console.error('Error deleting conversation:', error);
            setError('Something went wrong, please try again.');
        }
    };

    
    const receiveMessages = async () => {
        console.log("recieve messages: currentConversation:", currentConversation);
        try {
            const response = await axios.get(`${uri}/messages/conversation/${currentConversation._id}`);
            // const response = await axios.get(`${uri}/messages/getMessages/${currentConversation.users[1]}`);
            // problem: /getMessages is returning ALL messages that contain the currentUser as either sender or destination, regardless of currentConversation
            setMessageList(response.data);
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    };

    // Effect to fetch messages when the current conversation changes
    useEffect(() => {
        if (currentConversation && currentConversation._id) {
            console.log("Fetching messages for conversation:", currentConversation._id);
            receiveMessages();
        }
    }, [currentConversation]);

    return (
        <div className='conversationMainContent'>
            <Sidebar />
            <ConversationList
                conversationIds={conversationIds}
                currentUsername= {currentUsername}
                currentConversation={currentConversation}
                setCurrentConversation={setCurrentConversation}
                showModal={showModal}
                handleOpenModal={handleOpenModal}
                handleCloseModal={handleCloseModal}
                otherUsername={otherUsername}
                setOtherUsername={setOtherUsername}
                error={error}
                handleCreateConversation={handleCreateConversation}
            />
            {currentConversation && (
                
                <MessageLog
                    currentUsername= {currentUsername}
                    currentConversation={currentConversation}
                    messageList={messageList}
                    message={message}
                    setMessage={setMessage}
                    send={send}
                    deleteConversation={deleteConversation}
                />
                
            )}
        </div>
    );
}
